import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { DialogTitle, Typography } from '@material-ui/core';
import { eodItemStyles } from '../../eodItemStyles';

type CancelProps = {
  openCancelConfirmation: boolean;
  cancelEodProcess: () => void;
  backToList: () => void;
};

export const CancelEodDialog: FunctionComponent<CancelProps> = ({
  openCancelConfirmation,
  cancelEodProcess,
  backToList
}) => {
  const classes = eodItemStyles();
  return (
    <div>
      <Dialog aria-labelledby="customized-dialog-title" open={openCancelConfirmation} >
        <DialogTitle id="customized-dialog-title" style={{ backgroundColor: "#3d5a79" }}>
          <Typography className={classes.dialogTitleStyle}>
            Confirmation-Dialog
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Typography className={classes.errorMessageStyle}>
              Are you sure to want to cancel EOD process
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelEodProcess}>OK</Button>
          <Button onClick={backToList}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
